<template>
  <v-row class="ma-0" no-gutters>
    <v-col class="pa-0">
      <TrendingProductsClassic v-if="productFocused" />
      <TrendingEventsClassic v-else />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'TrendingItems',
  components: {
    TrendingProductsClassic: () =>
      import('./trendingProducts/TrendingProductsClassic.vue'),
    TrendingEventsClassic: () =>
      import('./trendingEvents/TrendingEventsClassic.vue'),
  },
  computed: {
    partnerGroupDetails() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },
    productFocused() {
      if (
        this.partnerGroupDetails == null ||
        this.partnerGroupDetails.Focus == null
      ) {
        return true;
      }
      if (this.partnerGroupDetails.Focus === 'Product') {
        return true;
      }
      return false;
    },
  },
};
</script>
